import script from "./LoadingScreen.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoadingScreen.vue?vue&type=script&setup=true&lang=ts"

import "./LoadingScreen.vue?vue&type=style&index=0&id=2b8f4586&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b8f4586"]])

export default __exports__